'use client'

import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'

import ProcurementAnimation from '@/components/MovingChipAnimation/ProcurementAnimation'
import useDevice from '@/hooks/useDevice'

const AutomateScope3Calculations = () => {
    const { smScreen, mdScreen } = useDevice()
    return (
        <>
            <Box>
                <Text
                    variant={mdScreen ? 'h5' : 'h4'}
                    sx={{ mb: 4, width: '100%', textAlign: smScreen ? 'left' : 'center' }}
                >
                    Automate best-in-class scope 3 emission calculations
                </Text>
                <Text
                    variant={mdScreen ? 'body2' : 'body1'}
                    sx={{ mb: 9, textAlign: smScreen ? 'left' : 'center' }}
                >
                    <>
                        Up to 50,000 emissions factors offering both spend-based and activity-based
                        calculations with granular product and materials categories and global
                        coverage. Using powerful artificial intelligence, Lune automatically matches
                        items with emissions data, freeing up your valuable time.
                    </>
                </Text>
                <ProcurementAnimation />
            </Box>
        </>
    )
}

export default AutomateScope3Calculations
